/**
 * L'annuaire des sites, vu par l'écran.
 *
 * Un site est un LIEU où l'on charge ou l'on livre. Ce n'est pas une entité
 * facturée : ni SIRET, ni TVA, ni conditions de paiement, ni encours — d'où
 * `conditions: false`, qui fait disparaître l'onglet Conditions de sa fiche.
 * Et `couverture: false` : un site ne roule pas.
 *
 * Sa fiche n'a donc que trois onglets — Identité, Contacts, Activité — là où un
 * client en a quatre et un transporteur cinq. C'est le descripteur qui le dit,
 * et non un `if` sur le nom de l'annuaire.
 *
 * Modèle arrêté le 03/09/2026 après lecture de la base réelle de TNS (classeur
 * « BASE PLANNING TRANSPORT », feuille `sites`, 24 lignes). **Pas de
 * rattachement à un client**, décidé par l'utilisateur : le lien viendra des
 * ordres de transport, dont chaque étape porte déjà les deux.
 *
 * Les `court` vont par paires, comme partout : code et pays, code postal et
 * ville, téléphone et courriel. Un `court` isolé laisserait un trou à sa
 * droite — constaté à l'écran le 03/09/2026.
 */

import type { Annuaire } from './annuaire.js';

export const ANNUAIRE_SITES: Annuaire = {
  chemin: 'sites',
  cleListe: 'sites',
  cleFiche: 'site',
  singulier: 'site',
  pluriel: 'sites',
  couverture: false,
  conditions: false,
  noteDesactive:
    'Il reste consultable, ainsi que les transports qui y sont déjà passés.',
  champs: [
    { cle: 'nom', etiquette: 'Nom', max: 200, obligatoire: true },
    { cle: 'code', etiquette: 'Code', max: 32, chiffre: true, court: true },
    { cle: 'pays', etiquette: 'Pays', max: 80, court: true, liste: 'pays' },
    { cle: 'adresse', etiquette: 'Adresse', max: 500 },
    {
      cle: 'code_postal',
      etiquette: 'Code postal',
      max: 16,
      chiffre: true,
      court: true,
    },
    { cle: 'ville', etiquette: 'Ville', max: 120, court: true },
    { cle: 'telephone', etiquette: 'Téléphone', max: 40, chiffre: true, court: true },
    { cle: 'courriel', etiquette: 'Courriel', max: 200, court: true },
    { cle: 'note', etiquette: 'Note', max: 2000, long: true },
  ],
};
